import api from "../index";
import urls from "./urls";
import baseUrl from "../baseUrl";

// const header = {}

export default {
  formatUrl(url) {
    if (process.env.VUE_APP_BASIC_API === "dev") {
      return url;
    } else {
      return baseUrl.getUrl() + url;
    }
  },
  getLoginUserInfo({ header, errorFn, loadingText }) {
    // return出去了一个promise
    return api.get({
      url: this.formatUrl(urls.getLoginUserInfo.url),
      params: {
        wsfunction: urls.getLoginUserInfo.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getCourseInfo({ params, header, errorFn, loadingText }) {
    // return出去了一个promise
    return api.get({
      url: this.formatUrl(urls.courseInfo.url),
      params: {
        ...params,
        wsfunction: urls.courseInfo.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getCourseContent({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.courseContent.url),
      params: {
        ...params,
        wsfunction: urls.courseContent.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getQuizList({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.quizList.url),
      params: {
        ...params,
        wsfunction: urls.quizList.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getCourseelfInfo({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getCourseelfInfo.url),
      params: {
        ...params,
        wsfunction: urls.getCourseelfInfo.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getModuleGroup({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getModuleGroup.url),
      params: {
        ...params,
        wsfunction: urls.getModuleGroup.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  editQuiz({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.editQuiz.url),
      params: {
        ...params,
        wsfunction: urls.editQuiz.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getGalleriesByCourseElf({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getGalleriesByCourseElf.url),
      params: {
        ...params,
        wsfunction: urls.getGalleriesByCourseElf.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getGalleriesFile({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getGalleriesFile.url),
      params: {
        ...params,
        wsfunction: urls.getGalleriesFile.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getQuestionIds({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getQuestionIds.url),
      params: {
        ...params,
        wsfunction: urls.getQuestionIds.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getQuizQustionDetail({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getQuizQustionDetail.url),
      params: {
        ...params,
        wsfunction: urls.getQuizQustionDetail.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  setQuizEnd({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.setQuizEnd.url),
      params: {
        ...params,
        wsfunction: urls.setQuizEnd.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  setQuizDelay({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.setQuizDelay.url),
      params: {
        ...params,
        wsfunction: urls.setQuizDelay.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getTimestamp({ header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getTimestamp.url),
      params: {
        wsfunction: urls.getTimestamp.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getAttendanceQrcode({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getAttendanceQrcode.url),
      params: {
        ...params,
        wsfunction: urls.getAttendanceQrcode.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getAttendanceInfo({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getAttendanceInfo.url),
      params: {
        ...params,
        wsfunction: urls.getAttendanceInfo.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getGalleryFiles({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getGalleryFiles.url),
      params: {
        ...params,
        wsfunction: urls.getGalleryFiles.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  getUsersByCourseid({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getUsersByCourseid.url),
      params: {
        ...params,
        wsfunction: urls.getUsersByCourseid.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取讨论区话题
  getForumsByCourseids({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getForumsByCourseids.url),
      params: {
        ...params,
        wsfunction: urls.getForumsByCourseids.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取讨论区话题
  getForumDiscussions({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getForumDiscussions.url),
      params: {
        ...params,
        wsfunction: urls.getForumDiscussions.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取投票结果
  getChoiceResult({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getChoiceResult.url),
      params: {
        ...params,
        wsfunction: urls.getChoiceResult.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取投票选项
  getChoiceOptions({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getChoiceOptions.url),
      params: {
        ...params,
        wsfunction: urls.getChoiceOptions.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取讨论区话题
  getChoiceByCourseId({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getChoiceByCourseId.url),
      params: {
        ...params,
        wsfunction: urls.getChoiceByCourseId.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取课堂资料
  getGalleriesByCourseelf({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getGalleriesByCourseelf.url),
      params: {
        ...params,
        wsfunction: urls.getGalleriesByCourseelf.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取gallery文件
  getFilesByGallery({ params, header, errorFn, loadingText }) {
    console.log("urls", urls.getFilesByGallery);
    return api.get({
      url: this.formatUrl(urls.getFilesByGallery.url),
      params: {
        ...params,
        wsfunction: urls.getFilesByGallery.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 更新gallery文件
  updateGallery({ params, header, errorFn, loadingText }) {
    console.log("urls", urls.updateGallery);
    return api.get({
      url: this.formatUrl(urls.updateGallery.url),
      params: {
        ...params,
        wsfunction: urls.updateGallery.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 更新gallery文件
  updateFile({ params, header, errorFn, loadingText }) {
    console.log("urls", urls.updateFile);
    return api.get({
      url: this.formatUrl(urls.updateFile.url),
      params: {
        ...params,
        wsfunction: urls.updateFile.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 更新活动状态
  updateModule({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.updateModule.url),
      params: {
        ...params,
        wsfunction: urls.updateModule.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 编辑讨论区
  editForum({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.editForum.url),
      params: {
        ...params,
        wsfunction: urls.editForum.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  quizCanEditQuestion({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.quizCanEditQuestion.url),
      params: {
        ...params,
        wsfunction: urls.quizCanEditQuestion.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 删除讨论区话题
  deleteDiscussionPost({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.deleteDiscussionPost.url),
      params: {
        ...params,
        wsfunction: urls.deleteDiscussionPost.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 讨论区话题回复列表
  getForumDiscussionPosts({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getForumDiscussionPosts.url),
      params: {
        ...params,
        wsfunction: urls.getForumDiscussionPosts.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 上传文件
  uploadFile({ params, errorFn, loadingText, progressCb }) {
    return new Promise((resolve, reject) => {
      console.log("repo_upload_file");
      api
        .post({
          url: this.formatUrl(urls.uploadFile.url),
          data: {
            ...params,
            wsfunction: urls.uploadFile.wsfunction
          },
          errorFn,
          showLoading: false,
          loadingText,
          progressCb
        })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 添加gallery文件
  addGallery({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.addGallery.url),
      params: {
        ...params,
        wsfunction: urls.addGallery.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 获取在线课程
  getOnlineCourses({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.getOnlineCourses.url),
      params: {
        ...params,
        wsfunction: urls.getOnlineCourses.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 下发信息
  sendMessage({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.sendMessage.url),
      params: {
        ...params,
        wsfunction: urls.sendMessage.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 推送活动
  setLog({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.setLog.url),
      params: {
        ...params,
        wsfunction: urls.setLog.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  },
  // 结束授课
  sendFinishTeaching({ params, header, errorFn, loadingText }) {
    return api.get({
      url: this.formatUrl(urls.sendFinishTeaching.url),
      params: {
        ...params,
        wsfunction: urls.sendFinishTeaching.wsfunction
      },
      header,
      errorFn,
      loadingText
    });
  }
};
